require("!!C:\\projects\\angesqc-mercure\\aspnet-core\\src\\AngesQc.Mercure.Web.Static\\node_modules\\script-loader\\addScript.js")(require("!!C:\\projects\\angesqc-mercure\\aspnet-core\\src\\AngesQc.Mercure.Web.Static\\node_modules\\raw-loader\\index.js!C:\\projects\\angesqc-mercure\\aspnet-core\\src\\AngesQc.Mercure.Web.Static\\node_modules\\startbootstrap-sb-admin\\vendor\\datatables\\dataTables.bootstrap4.js"))


//////////////////
// WEBPACK FOOTER
// ./~/startbootstrap-sb-admin/vendor/datatables/dataTables.bootstrap4.js
// module id = rJCR
// module chunks = 0